export const truncate = (text, suffix, num) => {
  if (text !== undefined && text.length > num) {
    const regex = /(<([^>]+)>)/ig
    const string = text.replace(regex, '')
    return string.substring(0, num) + suffix
  } else {
    return text
  }
}

const removeURLParameter = (url, parameter) => {
  // prefer to use l.search if you have a location/link object
  let urlParts = url.split('?')
  if (urlParts.length >= 2) {
    const prefix = encodeURIComponent(parameter) + '='
    const pars = urlParts[1].split(/[&;]/g)

    // reverse iteration as may be destructive
    for (let i = pars.length; i-- > 0;) {
      // idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1)
      }
    }

    return urlParts[0] + (pars.length > 0 ? '?' + pars.join('&') : '')
  }
  return url
}

const getUrlParameter = (url) => {
  const vars = {}
  url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    vars[key] = value
  })
  return vars
}

const getQueryString = (params) => {
  var parameters = params.split('&')
  var result = {}
  for (var i = 0; i < parameters.length; i++) {
    var element = parameters[i].split('=')
    var paramName = decodeURIComponent(element[0])
    var paramValue = decodeURIComponent(element[1])
    result[paramName] = decodeURIComponent(paramValue)
  }
  return result
}

export const Helpers = {
  truncate,
  removeURLParameter,
  getUrlParameter,
  getQueryString
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js